import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'asset.tracker',
    content: {
      root: {
        elements: [
          {
            content: {
              widget: {
                widget: {
                  alias: 'asset.tracker',
                },
              },
            },
            height: 400,
          },
          {
            content: {
              widget: {
                widget: {
                  alias: 'asset.organization.table',
                },
              },
            },
            height: 400,
          },
        ],
      },
    },
    description:
      'Explore AI-Enabled assets across the Attain Partners landscape',
    name: 'Asset Tracker',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
